module.exports = __webpack_public_path__ + "img/hero-gathering.0fa571ce.webp";